import React from 'react';
import { FaTwitter, FaLinkedin, FaGithub } from 'react-icons/fa';

const teamMembers = [
  {
    id: 1,
    name: 'Ngozi Ibekwe',
    role: 'CEO & Founder',
    image: 'https://images.unsplash.com/photo-1530785602389-07594beb8b73?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    twitter: 'https://twitter.com/janedoe',
    linkedin: 'https://linkedin.com/in/janedoe',
    github: 'https://github.com/janedoe',
  },
  {
    id: 2,
    name: 'Emeka Chukwuma',
    role: 'CTO',
    image: 'https://images.unsplash.com/photo-1531384441138-2736e62e0919?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    twitter: 'https://twitter.com/johnsmith',
    linkedin: 'https://linkedin.com/in/johnsmith',
  },
  {
    id: 3,
    name: 'Kemi Adebayo',
    role: 'Lead Designer',
    image: 'https://images.unsplash.com/photo-1655720357761-f18ea9e5e7e6?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    linkedin: 'https://linkedin.com/in/emilybrown',
    github: 'https://github.com/emilybrown',
  },
  {
    id: 4,
    name: 'Seyi Okon',
    role: 'Senior Developer',
    image: 'https://images.unsplash.com/photo-1495603889488-42d1d66e5523?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    twitter: 'https://twitter.com/michaeljohnson',
    github: 'https://github.com/michaeljohnson',
  },
];

const TeamProfiles = () => {
  return (
    <div className="container mx-auto px-4 py-16">
      <h2 className="text-4xl text-primary font-bold text-center mb-12 font-primary">Our Team</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {teamMembers.map((member) => (
          <div key={member.id} className="bg-white rounded-lg shadow-md shadow-slate-100 overflow-hidden transform transition duration-300 hover:scale-105">
            <img src={member.image || "/placeholder.svg"} alt={member.name} className="w-full h-64 object-cover object-center" />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-primary mb-2">{member.name}</h3>
              <p className="text-secondary mb-4">{member.role}</p>
              <div className="flex justify-center space-x-4">
                {member.twitter && (
                  <a href={member.twitter} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-600">
                    <FaTwitter size={24} />
                  </a>
                )}
                {member.linkedin && (
                  <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="text-blue-700 hover:text-blue-900">
                    <FaLinkedin size={24} />
                  </a>
                )}
                {member.github && (
                  <a href={member.github} target="_blank" rel="noopener noreferrer" className="text-gray-800 hover:text-gray-600">
                    <FaGithub size={24} />
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamProfiles;

